import React, { useState, useEffect, useReducer, useContext } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import Util from '../../../Util';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../../contexts/AuthContext';
import { apiRoutes } from '../../../AppSettings';
import alertify from "alertifyjs";

const WEEKLOAD_TYPE_PREVIOUS = 'PREVIOUS';
const WEEKLOAD_TYPE_NEXT = 'NEXT';
const LOAD_WEEK = "LOAD_WEEK";
const SELECT_TIME = "SELECT_TIME";
const LOAD_APPOINMENTS = "LOAD_APPOINMENTS";
const LOAD_SCHEDULES = "LOAD_SCHEDULES";

const initialState = {
    weekState: [],
    previousWeekDate: '',
    nextWeekDate: '',
    selectedTime: '',
    appoinments: [],
    scheduleTimes: []
};

const reducer = (state, action) => {
    switch(action.type)
	{
        case LOAD_WEEK:
            return { 
                ...state,
                weekState: action.weekState, 
                previousWeekDate: action.weekState[0].d, 
                nextWeekDate: action.weekState[action.weekState.length - 1].d,
                selectedTime: ''
            };
        case SELECT_TIME:
            return {
                ...state, 
                selectedTime: action.selectedTime
            };
        case LOAD_APPOINMENTS: 
            return {
                ...state,
                appoinments: action.appoinments
            }
        case LOAD_SCHEDULES:
            return {
                ...state,
                scheduleTimes: action.scheduleTimes
            }
        default:
            return state;
    }
}

const Booking = (props) => {
    const doctor = JSON.parse(props.location.state.selectedDoctor);
    const [state, dispature] = useReducer(reducer, initialState);
    const { userState } = useContext(AuthContext);
   
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    useEffect(() => {
        var weekToBeLoad = new Date();

        const lastTimeSlotOfWeek = Util.setHours(new Date(), '07:00 PM');
        
        if(lastTimeSlotOfWeek < new Date())
            weekToBeLoad = (new Date(weekToBeLoad)).setDate(new Date(weekToBeLoad).getDate() + 1);

        const week = Util.getWeekDates(weekToBeLoad);
        dispature({
            type: LOAD_WEEK, 
            weekState: week
        });

        axios.get(apiRoutes.getFutureAppoinments + doctor.doctorId, options)
        .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                dispature({
                    type: LOAD_APPOINMENTS, 
                    appoinments: data.data
                });
            }
        }, (error) => {
            console.log(error.response);
            alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
        });

        axios.get(apiRoutes.getScheduleTiming + doctor.doctorId, options)
        .then((response) => {
          if(response.status === 200)
          {
              const data = response.data;
         
              dispature({
                type: LOAD_SCHEDULES, 
                scheduleTimes: data.scheduleTimes
            });
          }
        }, (error) => {
          console.log(error.response);
          alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
      });

    }, []);

    const loadWeek = (e, weekToBeLoad, type) => {
        console.log('come here')
        e.preventDefault();
        switch(type)
        {
            case WEEKLOAD_TYPE_PREVIOUS:
                weekToBeLoad = (new Date(weekToBeLoad)).setDate(new Date(weekToBeLoad).getDate() - 1);
                break;
            case WEEKLOAD_TYPE_NEXT:
                weekToBeLoad = (new Date(weekToBeLoad)).setDate(new Date(weekToBeLoad).getDate() + 1);
                break;
        }
     
        const week = Util.getWeekDates(weekToBeLoad);
        dispature({
            type: LOAD_WEEK, 
            weekState: week
        });
    }

    const selectTime = (e, selectedTime) => {
        e.preventDefault();

        console.log(selectedTime);

        state.weekState.forEach(element => {
            element.timeEntry.forEach(time => {
                if(time.id == selectedTime)
                    time.selected = true;
                else
                    time.selected = false;
            })
        })
  
        dispature({
            type: LOAD_WEEK, 
            weekState: state.weekState
        });

        dispature({
            type: SELECT_TIME, 
            selectedTime: selectedTime
        });
    }

    const IsValidTime = (date, day, time) => {
        const datetoCompare = Util.setHours(date, time);
    
        if(datetoCompare < new Date())
            return false;

        var valid = true;

        if(state.appoinments != undefined )
        {
            for(let i = 0; i < state.appoinments.length; i++)
            {
                let element =  state.appoinments[i];
                var appoinmentDate = Util.setHours(new Date(element.appoinmentDate), element.appoinmentTime);
                if(datetoCompare.getDate() == appoinmentDate.getDate() 
                        && datetoCompare.getDay() == appoinmentDate.getDay()
                        && datetoCompare.getFullYear() == appoinmentDate.getFullYear() 
                        && time == element.appoinmentTime)
                {
                    valid = false;
                    break;
                }
            }
        }

        if(valid && state.scheduleTimes != undefined)
        {
            if(state.scheduleTimes[day] != undefined)
            {
                for (let i = 0; i < state.scheduleTimes[day].length; i++) {
                    let scheduleTime = state.scheduleTimes[day][i];
                    
                    let startTime = Util.setHours(date, scheduleTime.startTime);
                    let endTime = Util.setHours(date, scheduleTime.endTime);
                
                    if(dateCompare(datetoCompare, startTime, endTime)) {
                        valid = true;
                        break;
                    }
                    else {
                        valid = false;
                    }
                }
            }
        }

        return valid;
    }

    const dateCompare = (dateToCompare, startDate, endDate) => {
        return (dateToCompare.getTime() >= startDate.getTime() && dateToCompare.getTime() <= endDate.getTime())
    }

    return (
        <div>
            <Breadcrumb title="Booking" />
            <div className="content">
                <div className="container">

                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="booking-doc-info">
                                        <a href="doctor-profile.html" className="booking-doc-img">
                                            <img src={Util.loadImage(doctor.profileImage)} alt="User" />
                                        </a>
                                        <div className="booking-info">
                                            <h4><a href="doctor-profile.html">Dr. {doctor.firstName} {doctor.lastName}</a></h4>
                                            <div className="rating">
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star filled"></i>
                                                <i className="fas fa-star"></i>
                                                <span className="d-inline-block average-rating">35</span>
                                            </div>
                                            <p className="text-muted mb-0"><i className="fas fa-map-marker-alt"></i> {doctor.state}, {doctor.country}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-4 col-md-6">
                                    <h4 className="mb-1">{Util.getFormatDate({type: 'long'})}</h4>
                                    <p className="text-muted">{Util.getDayFullName()}</p>
                                </div>
                                <div className="col-12 col-sm-8 col-md-6 text-sm-right">
                                    <div className="color_schem"> <div className="disableColor"></div> Not Available </div>
                                </div>
                            </div>
                            <div className="card booking-schedule schedule-widget">

                                <div className="schedule-header">
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="day-slot">
                                                <ul>
                                                    <li className="left-arrow">
                                                        {
                                                            state.previousWeekDate < new Date() ?  
                                                                        <Link className="disabledCursor" data-toggle="tooltip" title="Can not shows appoinments for old dates" onClick={(e) => e.preventDefault()}>
                                                                            <i className="fa fa-chevron-left"></i>
                                                                        </Link>
                                                                    : 
                                                                    <Link onClick={(e) => loadWeek(e, state.previousWeekDate, WEEKLOAD_TYPE_PREVIOUS)}>
                                                                        <i className="fa fa-chevron-left"></i>
                                                                    </Link>
                                                        }
                                                    </li>
                                                    {
                                                        state.weekState != undefined &&
                                                        state.weekState.map(w => (
                                                            <li key={w.date}>
                                                                <span>{w.day}</span>
                                                                <span className="slot-date">{w.date}</span>
                                                            </li>
                                                        ))
                                                    }
                                                    <li className="right-arrow">
                                                        <Link onClick={(e) => loadWeek(e, state.nextWeekDate, WEEKLOAD_TYPE_NEXT)}>
                                                            <i className="fa fa-chevron-right"></i>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="schedule-cont">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="time-slot">
                                                <ul className="clearfix">
                                                    {
                                                        state.weekState != undefined &&
                                                        state.weekState.map(w => (
                                                            <li key={w.d}>
                                                                {
                                                                    w.timeEntry.map(t => (
                                                                        IsValidTime(w.d, w.fullDayName, t.time) ? 
                                                                        <Link key={t.id} className={t.selected ? "timing selected" : "timing" } onClick={(e) => selectTime(e, t.id)}>
                                                                            <span>{t.time}</span>
                                                                        </Link>
                                                                        :   <Link key={t.id} className="disableTiming disabledCursor" data-toggle="tooltip" title="Not Available" onClick={(e) => e.preventDefault()}>
                                                                                <span>{t.time}</span>
                                                                            </Link>
                                                                        
                                                                    ))
                                                                }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section proceed-btn text-right">
                                {
                                    state.selectedTime == '' ? 
                                    <Link className="btn btn-primary submit-btn disabledCursor" data-toggle="tooltip" title="Please select time before proceed" onClick={(e) => e.preventDefault()} >Proceed to Pay</Link>
                                    : <Link className="btn btn-primary submit-btn" to={
                                        {
                                            pathname: `/checkout`,
                                            state: {
                                                selectedDoctor: JSON.stringify(doctor),
                                                selectedTime: state.selectedTime
                                            }
                                        }
                                    }>Proceed to Pay</Link>
                                }
                            </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Booking;